import { Container } from '@material-ui/core';
import { Linked, useIO, useLinked, useModel } from '@type-r/react';
import { Button, FormLabel, InlineTable, Input, Loading, PopupDialog, PrimaryButton, TableCell, TableRow, div } from 'lqx-react';
import React from 'react';
import { PopupActionDialog } from '../components/popups/popup-action-dialog';
import { DigiCheckbox, ErrorHighligter } from '../shared';
import { NotificationSubscriptionDialogStore } from './models/notification-subscription-dialog-store';

export const NotificationSubscriptionDialog = ({ $isOpen, notificationSubscriptionId, onSuccess }: {
    $isOpen: Linked<boolean>,
    notificationSubscriptionId: string,
    onSuccess: () => void
}) => {
    const defaultContext = { onApply: null, onCancel: null, actionType: '', actionText: '', isPopupOpen: false };
    const $popupContext = useLinked<{
        onApply: any,
        onCancel: any,
        actionType: String,
        actionText: String,
        isPopupOpen: boolean
    }>(defaultContext);
    const state = useModel(NotificationSubscriptionDialogStore);
    const isEdit = notificationSubscriptionId != null;

    const isReady = useIO(async () => {
        await state.notificationTypes.fetch();
        if (notificationSubscriptionId) {
            state.notificationSubscription.id = notificationSubscriptionId;
            await state.notificationSubscription.fetch();
        }
    });

    const saveNotificationSubscription = async () => {
        await state.notificationSubscription.save();
        if (state.notificationSubscription.errorMessage) {
            throw new Error(state.notificationSubscription.errorMessage);
        }
        closePopup();
    };

    const confirmDelete = () => {
        $popupContext.set({
            onApply: async () => {
                await state.notificationSubscription.destroy();
                $popupContext.set(defaultContext);
                closePopup();
            },
            onCancel: () => $popupContext.set(defaultContext),
            actionType: "Delete",
            actionText: 'Are you sure you want to delete this recipient?',
            isPopupOpen: true
        });
    }

    const closePopup = () => {
        $isOpen.set(false);
        onSuccess();
    }

    return (
        $isOpen ?
            <PopupDialog
                title={isEdit ? "EDIT RECIPIENT" : "ADD RECIPIENT"}
                actions={<>
                    <Button onClick={() => $isOpen.set(false)}>Cancel</Button>
                    {isEdit && <PrimaryButton onClick={confirmDelete}>Delete</PrimaryButton>}
                    <PrimaryButton onClick={saveNotificationSubscription}>Save</PrimaryButton>
                </>}>
                {isReady ? <>
                    <Container>
                        <Label>Email address *</Label>
                        <ErrorHighligter error={state.notificationSubscription.errorMessage}>
                            <Input data-qa-id="email address" $value={state.notificationSubscription.$.email} />
                        </ErrorHighligter>
                        <br /><br />
                        <Label>Choose which notifications the above recipient will receive *</Label>
                        <InlineTable noBorders>
                            {state.notificationTypes.items.map(notificationType =>
                                <TableRow key={notificationType.cid}>
                                    <TableCell className="fit-width-tight">
                                        <DigiCheckbox $checked={state.notificationSubscription.subscriptions.$includes(notificationType)} />
                                    </TableCell>
                                    <TableCell>
                                        <FormLabel>{notificationType.description}</FormLabel>
                                    </TableCell>
                                </TableRow>
                            )}
                        </InlineTable>
                    </Container>
                </> : <Loading />}
                <PopupActionDialog $context={$popupContext} />
            </PopupDialog> : <></>
    )
}

export const Label = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#8695A4',
    padding: '5px 0px'
});
